import { api } from "../../app/api";

export const machinesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMachines: builder.query({
      query: ({
        page = 1,
        search = "",
        limit = 10,
        sort,
        isActive,
        ...params
      } = {}) => ({
        url: "/machines",
        params: {
          page,
          search,
          limit,
          sort,
          isActive,
          ...params,
        },
      }),
      transformResponse: (response) => ({
        ...response,
        data: response.data.map((machine) => ({
          ...machine,
          id: machine._id,
        })),
      }),
      providesTags: ["Machine"],
    }),

    getMachineById: builder.query({
      query: (id) => `/machines/${id}`,
      transformResponse: (machine) => ({
        ...machine,
        id: machine._id,
        size: machine.size,
        wilaya: machine.wilaya,
        code: machine.code || {},
      }),
      providesTags: (result, error, id) => [{ type: "Machine", id }],
    }),

    createMachine: builder.mutation({
      query: (newMachine) => ({
        url: "/machines",
        method: "POST",
        body: newMachine,
      }),
      transformResponse: (response) => {
        // response.data = { machine, code }
        const machine = response.data?.machine || {};
        const code = response.data?.code || {};
        return {
          ...machine,
          id: machine._id,
          code,
          api_key: code.blocks, // Example: show code blocks as API key
        };
      },
      invalidatesTags: [
        "Machine",
        "MachineVersion",
        { type: "MachineVersions", id: "LIST" },
        { type: "VersionMachines", id: "LIST" },
      ],
    }),

    updateMachine: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/machines/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [
        "Machine",
        "MachineVersion",
        { type: "MachineVersions", id: "LIST" },
        { type: "VersionMachines", id: "LIST" },
      ],
    }),

    deleteMachine: builder.mutation({
      query: (id) => ({
        url: `/machines/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        "Machine",
        "MachineVersion",
        { type: "MachineVersions", id },
        { type: "MachineVersions", id: "LIST" },
        { type: "VersionMachines", id: "LIST" },
      ],
    }),

    regenerateMachineApiKey: builder.mutation({
      query: (id) => ({
        url: `/machines/${id}/regenerate-key`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Machine", id }],
    }),

    getMachineLogs: builder.query({
      query: ({ id, limit = 100, offset = 0 }) => ({
        url: `/machines/${id}/logs`,
        params: { limit, offset },
      }),
      providesTags: (result, error, { id }) => [
        { type: "Machine", id: `${id}-logs` },
      ],
    }),

    toggleBlock: builder.mutation({
      query: (id) => ({
        url: `/machines/${id}/toggle-block`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [
        "Machine",
        { type: "Machine", id },
      ],
    }),

    toggleActive: builder.mutation({
      query: (id) => ({
        url: `/machines/${id}/toggle-active`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [
        "Machine",
        { type: "Machine", id },
      ],
    }),
  }),
});

export const {
  useGetMachinesQuery,
  useGetMachineByIdQuery,
  useCreateMachineMutation,
  useUpdateMachineMutation,
  useDeleteMachineMutation,
  useRegenerateMachineApiKeyMutation,
  useGetMachineLogsQuery,
  useToggleBlockMutation,
  useToggleActiveMutation,
} = machinesApi;
